import React from 'react';
import * as actions from '../../redux/actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';
import CommonService from '../../../../services/commonService';
import KuposHelmet from '../../../common/KuposHelmet';
import HeroSection from '../../common/HeroSection/HeroSection';
import ThemeFourTitle from '../common/ThemeFourTitle';
import ThemeFourOfficeSection from '../common/ThemeFourOfficeSection';

function ThemeFourOfficeScreen(props) {
  const operator = CommonService.getLocal('op') || props.home.operator;

  return (
    <div>
      <KuposHelmet />

      <HeroSection
        heroImage={getIcons('officeBanner', operator)}
        height={'43vh'}
        marginTop="-18px"
        title={'Oficinas'}
        description={'Home / Oficinas'}
      />

      <ThemeFourTitle title="Encuentra nuestras oficinas" />

      <ThemeFourOfficeSection office activeDotColor={operator && operator.color_codes && operator.color_codes.tertiary_color}/>
    </div>
  );
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeFourOfficeScreen);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeFour/ThemeFourPages/ThemeFourOfficeScreen.js